import { Component } from 'react'
import { get as _get } from 'lodash'
import { Slider } from '@chakra-ui/react'
import { Box, Text, Button, Icons } from 'stylewhere/components'
import { Storage } from 'stylewhere/shared'
import { TmrRfidAntenna } from 'stylewhere/api'

type SliderSettingsProps = {
  title: string
  workstationId: string
  antenna: TmrRfidAntenna
  field: string
  min: number
  max: number
  step?: number
  onSliderChange?: (workstationId, antennaId: string, value: number) => void
}

interface State {
  sliderValue?: number
  hasLocalStorage: boolean
}

export class SliderSettings extends Component<SliderSettingsProps, State> {
  state: State = {
    sliderValue: undefined,
    hasLocalStorage: false
  }

  componentDidMount() {
    this._init()
  }

  getStorageKey = () => {
    const { workstationId, antenna, field } = this.props
    return `Settings-${workstationId}-${antenna.id}-${field}`
  }

  _init = async () => {
    const { antenna, field, min, max } = this.props
    let value = _get(antenna, field)
    if (value < min) value = min
    else if (value > max) value = max

    const storageKey = this.getStorageKey()
    const userValue = Storage.load(storageKey)
    this.setState({ sliderValue: userValue ?? value, hasLocalStorage: userValue !== undefined })
  }

  onChange = async (val) => {
    this.setState({ sliderValue: val })
  }

  onChangeEnd = async (val) => {
    const { onSliderChange, antenna, workstationId } = this.props

    const storageKey = this.getStorageKey()
    Storage.save(storageKey, val)

    this.setState({ sliderValue: val, hasLocalStorage: true })

    onSliderChange?.(workstationId, antenna.id, val)
  }

  reset = async () => {
    const storageKey = this.getStorageKey()
    Storage.remove(storageKey)

    // set value to undefined for reset slider correctly
    this.setState({ sliderValue: undefined }, this.resetSliderValue)
  }

  resetSliderValue = () => {
    const { antenna, field } = this.props
    const value = _get(antenna, field)
    this.setState({ sliderValue: value, hasLocalStorage: false })
  }

  render() {
    const { title, min, max, step } = this.props
    const { sliderValue, hasLocalStorage } = this.state
    return (
      <Box flex row center mt={15} minheight={36}>
        <Text style={{ minWidth: 100 }}>{title}</Text>
        <Box flex ml={15}>
          {sliderValue !== undefined && (
            <Slider.Root
              defaultValue={[sliderValue]}
              min={min}
              max={max}
              step={step ?? 1}
              onValueChange={(details) => this.onChange(details.value[0])}
              onValueChangeEnd={(details) => this.onChangeEnd(details.value[0])}
            >
              <Slider.Control>
                <Slider.Track bg="#dcdcdc">
                  <Slider.Range bg="#3182CE" />
                </Slider.Track>
                <Slider.Thumb index={0} boxSize={5} />
              </Slider.Control>
            </Slider.Root>
          )}
        </Box>
        <Text
          style={{
            marginLeft: 20,
            backgroundColor: '#dcdcdc',
            borderRadius: 5,
            width: 50,
            textAlign: 'center',
            paddingTop: 3,
            paddingBottom: 3
          }}
        >
          {sliderValue}
        </Text>
        <Button
          style={{ marginLeft: 10 }}
          onClick={this.reset}
          variant="secondary"
          size="small"
          circle
          padding={'0px'}
          disabled={!hasLocalStorage}
        >
          <Icons.Delete width={16} height={16} />
        </Button>
      </Box>
    )
  }
}
